import React, { useState, FC } from 'react'

import { CreateToolbar, AsidePreview, EditForm } from '../containers'
import { EditProps, Edit, SimpleForm, Button } from 'react-admin'
import * as actions from 'customReducers/popupReducer/actions'
import { FormProvider } from 'contexts'

import { Drawer } from 'components'

import { CreateStylesheetPopup } from 'modules/stylesheet'

import { useSelector, useDispatch } from 'react-redux'

interface PopupModuleStateProps {
  popupModule: {
    formData: object
    openStylesheets: boolean
  }
}

interface ResponseItemProps {
  id: number
  slug?: string
  path?: string
  title?: string
  type?: string
  vimeo_id?: string
}

export const EditPopup: FC<EditProps> = (props: any) => {
  const dispatch = useDispatch()
  const {
    showAside = false,
    shouldRedirect = true,
    closeDrawer = false,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
  } = props

  const popupModuleState = useSelector(
    (state: PopupModuleStateProps) => state.popupModule,
  )

  const [formData, setFormData] = useState([])

  return (
    <>
      <Drawer open={popupModuleState.openStylesheets} anchor="right">
        <CreateStylesheetPopup
          {...props}
          shouldRedirect={false}
          showAside={false}
          onSubmitSuccess={(data: ResponseItemProps) =>
            dispatch(actions.stylesheetsDialog())
          }
          onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
          closeDrawer={
            <Button
              label="Cancelar"
              redirect={false}
              submitOnEnter={false}
              variant="text"
              color="primary"
              onClick={() => dispatch(actions.stylesheetsDialog())}
            />
          }
        />
      </Drawer>
      <Edit {...props}>
        <SimpleForm>
          <FormProvider>
            <EditForm
              {...props}
              setFormData={setFormData}
              formData={formData}
              toolbar={<CreateToolbar closeDrawer={closeDrawer} />}
              aside={showAside ? <AsidePreview formData={formData} /> : <></>}
              onSubmitSuccess={onSubmitSuccess}
              onSubmitFailure={onSubmitFailure}
              shouldRedirect={shouldRedirect}
              resource="cms/grouper/popup"
            />
          </FormProvider>
        </SimpleForm>
      </Edit>
    </>
  )
}
